<template>
  <div class="auth-admin-content" v-loading="loading">
    <div class="head_body">
      <el-form ref="form" :model="filter" class="search_head">
        <el-row :gutter="20" class="list-head">
          <el-col :span="4">
            <el-form-item :label="$t('manage.user_account')">
              <el-input v-model="filter.username" :placeholder="$t('manage.keywords')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('manage.phone')">
              <el-input v-model="filter.mobile" :placeholder="$t('manage.keywords')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$t('manage.contact')">
              <el-input v-model="filter.contact" :placeholder="$t('manage.keywords')" clearable/>
            </el-form-item>
          </el-col>
          <el-col :span="2" class="search-btn-box">
              <el-button type="primary" size="small" @click="headSearch"><svg-icon name="search"></svg-icon>{{$t('control.search')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="h20"></div>
    <div class="con-body">
      <div class="control-group">
        <div class="group-left">
          <el-button
            type="primary"
            size="small"
            @click="openEditWin('create')"
            class="insert-btn"
            ><svg-icon name="add-plus"></svg-icon>{{$t('manage.add_user')}}</el-button
          >
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="id" :label="$t('manage.user_id')" width="100"></el-table-column>
        <el-table-column prop="username" :label="$t('manage.user_account')"></el-table-column>
        <el-table-column prop="company_name" :label="$t('manage.company')"></el-table-column>
        <el-table-column prop="contact" :label="$t('manage.contact')"></el-table-column>
        <el-table-column prop="mobile" :label="$t('manage.phone')"></el-table-column>
        <el-table-column v-if="$store.state.user.role_type==1" :label="$t('manage.basic_config')" align="center">
          <template slot-scope="scope">
            <i
              class="el-icon-setting pointer"
              @click="openBaseSet(scope.row)"
              :title="$t('manage.basic_config')"
            ></i>
          </template>
        </el-table-column>
        <el-table-column v-if="$store.state.user.role_type==1" :label="$t('manage.column_config')" align="center">
          <template slot-scope="scope">
            <i
              class="el-icon-setting pointer"
              @click="OpenTree(scope.row.id, scope.row.brc)"
              :title="$t('manage.column_config')"
            ></i>
          </template>
        </el-table-column>
        <el-table-column prop="status" :label="$t('device.state')" width="120">
          <template slot-scope="scope"
            ><span :style="{ color: arrStateColor[scope.row.status] }">{{
              arrState[scope.row.status]
            }}</span></template
          >
        </el-table-column>
        <el-table-column prop="edit" :label="$t('control.operate')" width="100">
          <template slot-scope="scope">
            <i
              @click="(dialogVisible = true), openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i class="el-icon-delete pointer" @click="delItem(scope.row.id)"></i>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageInfo.pageSize"
        layout="sizes, total, prev, pager, next, jumper"
        :total="cnt_all"
      >
      </el-pagination>
    </div>
    <!--添加修改-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? $t('control.add') : $t('control.edit')"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
    >
      <el-form
        :model="editOne"
        :rules="editOneRule"
        ref="dialogRef"
      >
        <div class="form-info">
          <el-form-item :label="$t('manage.user_account')" prop="username">
            <el-input
              v-model="editOne.username"
              :disabled="editType === 'update'"
            ></el-input>
          </el-form-item>

          <el-form-item :label="$t('manage.password')">
            <el-input v-model="editOne.password" placeholder="************"></el-input>
          </el-form-item>

          <el-form-item :label="$t('manage.company')" prop="company_id">
            <el-select
              :placeholder="$t('manage.company')"
              v-model="editOne.company_id"
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="t in companyList"
                :key="t.company_id"
                :label="t.company_name"
                :value="t.company_id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('manage.phone')" prop="mobile">
            <el-input v-model="editOne.mobile"></el-input>
          </el-form-item>

          <el-form-item :label="$t('manage.contact')" prop="contact">
            <el-input v-model="editOne.contact"></el-input>
          </el-form-item>

          <el-form-item :label="$t('manhole.describe')" prop="remark">
            <el-input v-model="editOne.remark" type="textarea"></el-input>
          </el-form-item>

          <el-form-item :label="$t('manage.is_enabled')" prop="status">
            <el-switch
              v-model="editOne.status"
              :active-value="1"
              :inactive-value="0"
              :active-text="$t('manage.enabled')"
              :inactive-text="$t('manage.disable')"
            >
            </el-switch>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >{{$t('control.confirm')}}</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>

    <!--权限管理-->
    <el-dialog
      class="dialog600"
      v-if="dialogTreeVisible"
      :title="$t('manage.auth')"
      :visible.sync="dialogTreeVisible"
    >
      <el-form>
        <div class="box-info">
          <el-form-item :label="$t('manage.column')" prop="brc">
            <div class="rolePower">
              <el-tree
                ref="tree"
                style="overflow: auto"
                node-key="id"
                :data="treeData"
                show-checkbox
                default-expand-all
                :props="defaultProps"
              >
              </el-tree>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTreeVisible = false"
          >{{$t('control.cancel')}}</el-button
        >
        <el-button
          type="primary"
          @click="setTree"
          >{{$t('control.confirm')}}</el-button
        >
      </div>
    </el-dialog>

    <!--基础配置-->
    <el-dialog
      :title="$t('manage.basic_config')+'['+baseData.username+']'"
      :visible.sync="baseData.dialogVisible"
      v-if="baseData.dialogVisible"
    >
      <base-set
        :userId="baseData.id"
        ref="baseSet"
        @closeMethod="closeBaseSet"
      ></base-set>
    </el-dialog>
  </div>
</template>

<script>
import configApi from "@/api/system/config";
import adminsApi from "@/api/system/admin";
import companyApi from "@/api/system/company";
import baseSet from "@/components/system/user/baseSet.vue";
import commonJs from '@/utils/common'
export default {
  components: {
    baseSet
  },
  data() {
    return {
      arrState: this.$t('manage.arrState'),
      arrStateColor: ['#F56C6C','#67C23A'],
      loading: false,
      tableData: [],
      pageInfo: {
        sortBy: 'id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 20
      },
      filter: {
        username: '',
        mobile: '',
        contact: ''
      },
      companyList: [],
      cnt_all: 0,
      editIndex: -1,
      editOne: {},
      dialogVisible: false,
      dialogTreeVisible: false,
      editOneRule: {
        username: [
          { required: true, message: this.$t('manage.user_account'), trigger: "blur" },
        ],
        company_name: [
          { required: true, message: this.$t('manage.please_company'), trigger: "blur" },
        ],
        mobile: [
          { required: true, message: this.$t('manage.phone'), trigger: "blur" },
        ],
        contact: [{ required: true, message: this.$t('manage.contact'), trigger: "blur" }],
        title: [{ required: true, message: this.$t('manage.title'), trigger: "blur" }],
      },

      treeData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      editTree:{},
      baseData:{
        id: null,
        username: '',
        dialogVisible: false
      }
    };
  },
  created() {
    this.getTableData(this.pageInfo.page);
    this.getCompanyList()
    this.getNodeData()
  },
  methods: {
    getTableData(pageIndex) {
      this.loading = true;
      this.pageInfo.filter = ''
      this.pageInfo.page = pageIndex;
      let filter = this.filter;
      filter = filter && commonJs.obj.removeNullKey(filter);
      if (filter && Object.keys(filter).length) {
        this.pageInfo.filter = JSON.stringify(filter);
      }
      adminsApi.getAdmin(this.pageInfo).then((res) => {
        this.loading = false;
        let resData = res.data.data;
        this.tableData = resData.list;
        this.pageInfo.page = pageIndex;
        this.cnt_all = parseInt(resData.count);
      });
    },
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },
    getCompanyList() {
      companyApi.getCompany({
        sortBy: 'company_id',
        descending: 'desc',
        filter: '',
        page: 1,
        pageSize: 500
      }).then((res) => {
        let resData = res.data.data;
        this.companyList = resData.list;
      });
    },
    openEditWin(index) {
      if (index === "create") {
        this.fileList= []
        this.editOne = {
          username: '',
          password: '',
          company_id: '',
          avatar: '',
          mobile: '',
          contact: '',
          remark: '',
          status: '',
          employee_name: ''
        };
        this.editType = "create";
      } else {
        let status = index.status == '1' || index.status == 1 ? 1 : 0;
        this.editOne = {
          id: index.id,
          username: index.username,
          password: '',
          company_id: index.company_id,
          avatar: index.avatar,
          mobile: index.mobile,
          contact: index.contact,
          remark: index.remark,
          status: status,
          employee_name: index.employee_name
        };
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          adminsApi.adminEdit(this.editOne.id, this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.mod_success'));
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    createItem() {
      this.$refs["dialogRef"].validate((valid) => {
        if (valid) {
          if (this.editOne.password=='') {
            return this.$message.error(this.$t('manage.set_password'));
          }
          adminsApi.adminAdd(this.editOne).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.add_success'));
              this.dialogVisible = false;
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
    delItem(id) {
      this.$confirm(this.$t('control.tip_del_data_title'), this.$t('control.tip'), {
        confirmButtonText: this.$t('control.confirm'),
        cancelButtonText: this.$t('control.cancel'),
        type: "warning",
      })
        .then(() => {
          adminsApi.adminDel(id).then((res) => {
            if (res.data.code === 1000) {
              this.$message.success(this.$t('control.del_success'));
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('control.cancel_del'),
          });
        });
    },
    //Open 栏目权限
    OpenTree(id,brc) {
      this.dialogTreeVisible = true;
      if (brc.endsWith(',')) {
        brc = brc.slice(0, -1);
      }
      let brc_arr=brc.split(',')
      for (let i = brc_arr.length - 1; i >= 0; i--) {
        let isChildren = this.getTreeDataChildrenLength(brc_arr[i]);
        if (isChildren) {
          brc_arr.splice(i, 1);
        }
      }
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(brc_arr)
      })
      this.editTree = {
        id: id,
        brc: brc
      }
    },
    getTreeDataChildrenLength(str) {
      let element = this.treeData.find(item => item.id === parseInt(str));
      if (element && element.children) {
        return element.children.length;
      } else {
        return 0;
      }
    },
    setTree () {
      this.$nextTick(() => {
        let newBrc = this.$refs.tree.getCheckedKeys().toString()
        let newBrc2 = this.$refs.tree.getHalfCheckedKeys().toString()
        newBrc= newBrc +','+ newBrc2
        adminsApi.updateUserMenus(this.editTree.id, {menu_ids:newBrc}).then((res) => {
          if (res.data.code === 1000) {
            this.dialogTreeVisible = false
            this.getTableData(this.pageInfo.page);
          } else {
            this.$message.error(res.data.message);
          }
        });
      })
    },
    
    //栏目权限列表
    getNodeData() {
      configApi.getNodeTree().then((res) => {
        if (res.data.code === 1000) {
          const resData = res.data.data;
          let treeData = []
          for (let i = 0; i < resData.length; i++) {
            let node = {
              id: resData[i].id,
              label: this.$i18n.locale=='en-US'?resData[i].en_name:resData[i].menu_name,
              children: []
            };

            if (resData[i].children) {
              for (let j = 0; j < resData[i].children.length; j++) {
                let childNode = {
                  id: resData[i].children[j].id,
                  label: this.$i18n.locale=='en-US'?resData[i].children[j].en_name:resData[i].children[j].menu_name
                };
                node.children.push(childNode);
              }
            }

            treeData.push(node);
          }
          // console.log('treeData', treeData)
          this.treeData = treeData;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    openBaseSet(value) {
      let newParams = { 
        id: value.id,
        username: value.username,
        dialogVisible: true
      }
      this.baseData = newParams
    },
    closeBaseSet() {
      this.baseData = {
        id: null,
        username: '',
        dialogVisible: false
      }
    },
    headSearch() {
      this.pageInfo.page = 1
      this.pageInfo.pageSize = 20
      this.getTableData(1)
    }
  }
};
</script>
<style lang='less'>
.auth-admin-content {
  width: 100%;
  position: relative;
  .el-form-item__content {
    height: auto !important;
  }
  .rolePower{
    border:1px solid #dcdfe6;
    padding: 20px;
    border-radius: 4px;
  }
  .form-info{
    padding-left: 0;
    .el-form-item__label{
      width:90px;
    }
  }
}
</style>